import styled, { css } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

const printStyles = css`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PageTitle = styled.h1<{ $size?: 'large' | 'xlarge' }>`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${({ $size }) => ($size === 'xlarge' ? '36px' : '23px')};
  font-weight: ${({ $size }) => ($size === 'xlarge' ? 600 : 700)};
  color: ${cardisTheme.colors.primary};
  margin: 0 0 38px 0;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media print {
    font-size: ${({ $size }) =>
      $size === 'xlarge' ? '36px' : '23px'} !important;
    font-weight: ${({ $size }) => ($size === 'xlarge' ? 600 : 700)} !important;
    color: ${cardisTheme.colors.primary} !important;
    margin: 0 0 38px 0 !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
    ${printStyles}
  }
`

export const SectionTitle = styled.h2`
  font-family: ${cardisTheme.fonts.body};
  font-size: 13px;
  font-weight: 600;
  color: ${cardisTheme.colors.primary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 13px 0;

  @media print {
    font-size: 13px !important;
    font-weight: 600 !important;
    color: ${cardisTheme.colors.primary} !important;
    ${printStyles}
  }
`

export const SubSectionTitle = styled.h3`
  font-family: ${cardisTheme.fonts.body};
  font-size: 10px;
  font-weight: 500;
  color: ${cardisTheme.colors.primary};
  margin: 0 0 10px 0;

  @media print {
    font-size: 10px !important;
    font-weight: 500 !important;
    color: ${cardisTheme.colors.primary} !important;
    ${printStyles}
  }
`

export const BodyText = styled.p`
  font-family: ${cardisTheme.fonts.body};
  font-size: 10px;
  color: ${cardisTheme.colors.textDark};
  line-height: 1.7;
  text-align: justify;
  margin: 0;

  @media print {
    font-size: 10px !important;
    color: ${cardisTheme.colors.textDark} !important;
    line-height: 1.7 !important;
    ${printStyles}
  }
`

export const SmallText = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 10px;
  color: ${cardisTheme.colors.textGray};

  @media print {
    font-size: 10px !important;
    color: ${cardisTheme.colors.textGray} !important;
    ${printStyles}
  }
`

export const Footnote = styled.p`
  font-family: ${cardisTheme.fonts.body};
  font-size: 10px;
  font-weight: 400;
  color: ${cardisTheme.colors.textGray};
  margin: 6px 0 0 0;
  font-style: italic;

  @media print {
    font-size: 10px !important;
    color: ${cardisTheme.colors.textGray} !important;
    margin: 6px 0 0 0 !important;
    ${printStyles}
  }
`
